module.exports = __webpack_public_path__ + "static/img/12areaA_13.68323c8.png";


//////////////////
// WEBPACK FOOTER
// ./static/mycard/character1/文字バージョン/12areaA_13.png
// module id = 965
// module chunks = 1